module.exports = __webpack_public_path__ + "img/vehicleFerryWhite.a42c229a.svg";